import cryptoJs from 'crypto-js'
const keyValue = 'l1jxd72qi6ujlo8@lonp#h$!xag1wsty'
export default {
    // 加密
    encrypt(message,keyStr) {
      let keyHex = cryptoJs.enc.Utf8.parse(keyStr || keyValue)
      let iv = cryptoJs.enc.Utf8.parse(128);
      let option = { iv, mode: cryptoJs.mode.ECB, padding: cryptoJs.pad.Pkcs7 }

      let encrypted = cryptoJs.AES.encrypt(message, keyHex, option)
      return encrypted.toString()
    },
    // 解密
    decrypt(message,keyStr) {
      let keyHex = cryptoJs.enc.Utf8.parse(keyStr || keyValue);
      let iv = cryptoJs.enc.Utf8.parse(128);
      let decrypted = cryptoJs.AES.decrypt(
        message,
        keyHex,
        {
          iv,
          mode: cryptoJs.mode.ECB,
          padding: cryptoJs.pad.Pkcs7
        }
      )
      return decrypted.toString(cryptoJs.enc.Utf8)
    }
}